module.exports = __webpack_public_path__ + "static/img/課長-張靖彬.9451baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/課長-張靖彬.png
// module id = Dm9u
// module chunks = 1